import { useActions, useState, useGetters, useMutations } from './global';
export const useNamespacedActions = useActions;
export const useNamespacedGetters = useGetters;
export const useNamespacedMutations = useMutations;
export const useNamespacedState = useState;
export function createNamespacedHelpers(storeOrNamespace, namespace) {
    let store = undefined;
    if (arguments.length === 1) {
        namespace = storeOrNamespace;
    }
    else {
        store = storeOrNamespace;
        if (!namespace) {
            throw new Error('Namespace is missing to provide namespaced helpers');
        }
    }
    return {
        useState: (map) => useState(store, namespace, map),
        useGetters: (map) => useGetters(store, namespace, map),
        useMutations: (map) => useMutations(store, namespace, map),
        useActions: (map) => useActions(store, namespace, map),
    };
}
//# sourceMappingURL=namespaced.js.map